import OrdersView from "./OrdersView";

export default OrdersView;
